import React, { useEffect, useRef, useState } from "react";

const VideoPlayer = ({
  mp4,
  webm,
  resumeTime = 0,
  onProgress,
  onComplete,
  autoPlay = true,
  allowReplay = true,
}) => {
  const [marked, setMarked] = useState(false);
  const videoRef = useRef(null);
  const lastReportRef = useRef(0);

  /* ---------------- Resume Position ---------------- */
  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;
    if (resumeTime <= 1) return;

    const seek = () => {
      vid.currentTime = resumeTime;
      vid.removeEventListener("loadedmetadata", seek);
    };

    vid.addEventListener("loadedmetadata", seek);
  }, [resumeTime]);

  /* ---------------- Throttled Progress Save ---------------- */
  const handleTimeUpdate = (e) => {
    const vid = e.target;
    if (!vid.duration) return;

    const now = Date.now();
    if (now - lastReportRef.current >= 1000) {
      onProgress?.(vid.currentTime);
      lastReportRef.current = now;
    }

    const progress = vid.currentTime / vid.duration;
    // Only mark complete when effectively 100% watched; allow minor floating error
    if (progress >= 0.999 && !marked) {
      markComplete();
    }
  };

  /* ---------------- Ended Event ---------------- */
  const handleEnded = () => {
    if (!marked) markComplete();
  };

  /* ---------------- Mark Complete ---------------- */
  const markComplete = () => {
    setMarked(true);
    onComplete?.();
  };

  return (
    <div className="relative bg-black rounded-xl overflow-hidden mb-6 border border-gray-200 shadow-subtle">
      <div className="aspect-video">
        <video
          ref={videoRef}
          controls
          autoPlay={autoPlay}
          playsInline
          preload="metadata"
          className="w-full h-full object-cover rounded-xl"
          onTimeUpdate={handleTimeUpdate}
          onEnded={handleEnded}
          // 🔒 Disable right-click + prevent download menu
          onContextMenu={(e) => e.preventDefault()}
          controlsList="nodownload noremoteplayback nopictureinpicture noplaybackrate"
          disablePictureInPicture
        >
          {/* Sources or fallback */}
          {mp4 && <source src={mp4} type="video/mp4" />}
          {webm && <source src={webm} type="video/webm" />}
          {!mp4 && !webm && "Video source not available"}
        </video>
      </div>

    </div>
  );
};

export default VideoPlayer;


